import React, { useState } from 'react'
import { IoLogoInstagram } from 'react-icons/io';
import { TbBrandFacebook, TbBrandInstagram, TbBrandWhatsapp } from 'react-icons/tb';
import { Link, useSearchParams, useLocation } from 'react-router-dom';
import Logo from '../../assets/logo2.png'; // Adjust the path as necessary
import Logo1 from '../../assets/VESHH-EON TYPE.png';
import Marquee from '../../components/Layout/marquee.jsx';
import Marquee2 from '../../components/Layout/marquee2.jsx';

const Footer = () => {
  const [email, setEmail] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [messageType, setMessageType] = useState(''); // 'success' or 'error'

  const handleNewsletterSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setMessage('');

    try {
      // Create form data for Google Forms submission
      const formData = new FormData();
      formData.append('entry.1283268949', email);

      // Submit to Google Forms
      await fetch('https://docs.google.com/forms/d/e/1FAIpQLScZy4V64A1RTrTx-NmiFbBCUvHTDHFXgiPkGme6u9kLLYMzEg/formResponse', {
        method: 'POST',
        mode: 'no-cors', // Important: This prevents CORS issues
        body: formData
      });

      // Since we're using no-cors, we can't check the response
      // But Google Forms will accept the submission
      setMessage('Successfully subscribed to newsletter!');
      setMessageType('success');
      setEmail(''); // Clear the input

    } catch (error) {
      console.error('Newsletter subscription error:', error);
      // Even if there's an error, the submission likely went through with no-cors
      setMessage('Subscription submitted! Thank you for subscribing.');
      setMessageType('success');
      setEmail(''); // Clear the input anyway
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <footer className="border-t mt-10 bg-black">
      {/* <Marquee /> */}
      {/* <Marquee direction="left" /> */}

      <div className="py-8 "> 
        <div className="container mx-auto grid grid-cols-1 md:grid-cols-5 gap-8 px-4 lg:px-0">
          {/* Logo */}
          <div className="flex flex-col items-start w-full  ">
            {/* <img src="https://res.cloudinary.com/dmrlotfsv/image/upload/v1754071341/VESHH-EON_TYPE_WEB_ppfyxy.png" className=" py-10 px-5 w-full"  /> */}
           

            {/* Logo Glitch Video */}
{/* <video 
  src="https://res.cloudinary.com/dmrlotfsv/video/upload/v1760166667/LOGO_GLITCH_EFFECT_fiz05a.mp4" 
  autoPlay 
  muted 
  loop 
  playsInline
  preload="metadata"
  loading="lazy"
  controlsList="nodownload"
  disablePictureInPicture
  onContextMenu={(e) => e.preventDefault()}
  style={{ pointerEvents: 'none' }}
/> */}
              
            <Link to="/" className="flex items-center w-sm">
              <img src={Logo} alt="VESHH-EON Logo" loading="lazy"  />
            </Link>

              
          </div>
           {/* <Marquee2 /> */}
          {/* <div className="md:hidden">
          <Marquee direction="right" />
          </div> */}

          <div>
            <h3 className="text-lg text-white mb-2">Newsletter</h3>
            <p className="text-gray-500 mb-4">
              Be the first to know about new Arrivals, Sales, And Special Offers.
            </p>
            {/* <p className="font-medium text-sm text-gray-800 mb-2"> */}
            <p className="font-medium text-sm text-white mb-2">
              Sign-up and get 10% off your first order.
            </p>

            {/* Newsletter form */}
            <form className="flex items-center mb-2" onSubmit={handleNewsletterSubmit}>
              <input
                type="email"
                placeholder="Enter your email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="border border-white bg-black hover:bg-gray-700 rounded-l px-4 py-2 w-full"
                required
                disabled={isLoading}
              />
              <button
                type="submit"
                disabled={isLoading}
                className="border border-white bg-black text-white px-4 py-2 rounded-r hover:bg-gray-700 disabled:opacity-50">
                {isLoading ? 'Subscribing...' : 'Subscribe'}
              </button>
            </form>
            
            {/* Message display */}
            {message && (
              <p className={`text-sm mt-2 ${
                messageType === 'success' ? 'text-green-600' : 'text-red-600'
              }`}>
                {message}
              </p>
            )}
          </div>

          {/* Shop Links gray-800*/}
          <div>
            <h3 className="text-lg text-white mb-2">Shop</h3>
            <ul className="text-gray-500 space-y-2">
              <li><a href="/collections/all" className="hover:text-gray-800">New Launches</a></li>
              <li><a href="/collections/Tie Dye Oversized T-Shirt" className="hover:text-gray-800">Tie Dye Oversized T-Shirt</a></li> 
              <li><a href="/collections/Acid Washed Oversized T-Shirt" className="hover:text-gray-800">Acid Washed Oversized T-Shirt</a></li>
              <li><a href="/collections/SweatShirt" className="hover:text-gray-800">SweatShirt</a></li>
              <li><a href="/collections/Oversized SweatShirt" className="hover:text-gray-800">Oversized SweatShirt</a></li>
              <li><a href="/collections/Hoodie" className="hover:text-gray-800">Hoodie</a></li>
              <li><a href="/collections/Oversized Hoodie" className="hover:text-gray-800">Oversized Hoodie</a></li>
              <li><a href="/collections/Acid Washed Hoodie" className="hover:text-gray-800">Acid Washed Hoodie</a></li>
{/*               <li><a href="/products" className="hover:text-gray-800">T-Shirts</a></li>
              <li><a href="/products" className="hover:text-gray-800">Hoodies</a></li> */}
            </ul> 
          </div>

          {/* Support Links gray-800*/}
          <div>
            <h3 className="text-lg text-white mb-2">Support</h3>
            <ul className="text-gray-500 space-y-2">
              <li><a href="/contact" className="hover:text-gray-800">Contact Us</a></li>
              <li><a href="/about" className="hover:text-gray-800">About Us</a></li> 
{/*               <li><a href="/products" className="hover:text-gray-800">FAQs</a></li> */}
              <li><a href="https://veshh-eon-creator-program.vercel.app/" className="hover:text-gray-800">Collaborations</a></li>

              <li><a href="/returnpolicy" className="hover:text-gray-800">Return Policy</a></li>
              <li><a href="/return" className="hover:text-gray-800">Return</a></li>
              <li><a href="/terms" className="hover:text-gray-800">Terms And Condition</a></li>
              <li><a href="/shipping" className="hover:text-gray-800">Shipping</a></li>
              
            </ul> 
          </div>

          {/* Follow Us gray-800*/}
          <div>
            <h3 className="text-lg text-white mb-2">Follow Us</h3>
            <div className="flex items-center space-x-4 mb-2"> 
              <a href="https://www.facebook.com" target="_blank" rel="noopener noreferrer" className="text-gray-500 hover:text-gray-800">
                <IoLogoInstagram className="h-5 w-5" />
              </a>
              <a href="https://www.instagram.com" target="_blank" rel="noopener noreferrer" className="text-gray-500 hover:text-gray-800">
                <TbBrandFacebook className="h-5 w-5"/>
              </a>
              <a href="https://www.twitter.com" target="_blank" rel="noopener noreferrer" className="text-gray-500 hover:text-gray-800">
                <TbBrandWhatsapp className="h-5 w-5" />
              </a>
            </div>
          </div>
        </div>
      </div>
      <img className="mt-0 w-full" src="https://res.cloudinary.com/dukimifv5/image/upload/q_auto:good/f_webp/Footer_img_pkqj3i"></img>
      {/* gray-500 */}
      <p className="container text-white text-sm tracking-tighter text-center mx-auto pb-1 px-4 lg:px-0 bordet-t border-gray-200 pt-6">
        © {new Date().getFullYear()} DRIPP TOUR. All rights reserved.
      </p>
    </footer>
  );
};

export default Footer;
